import { BaseService } from '@flint/framework';

export default class GetSubscription extends BaseService {
  constructor() {
    super("FETCHING_SUBSCRIPTION_DATA", 'GetSubscriptionStore', true);
  }

  handleEvent(eventName, ID) {
    return this.getClient('vetService').get(`/admin-api/subscriptions/${ID}`);
  }
}